/* eslint-disable @typescript-eslint/no-explicit-any */
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
import {
  AddressVo,
  IApplyReasonReq,
  ApplyReasonResVo,
  IRecordApplyInfoReq,
  RecordApplyInfoResVo,
  IRecordApplyCreateReq,
  RecordApplyCreateResVo,
  IRecordListReq,
  RecordListResVo,
  IRecordDetailReq,
  RecordDetailResVo,
  ICancelRecordReq,
  CancelAfsRecorResVo,
  IPostHouseListReq,
  PostHouseListResVo,
  IRefundListReq,
  RefundListApiResVo,
  RuleInfoVO,
  ITraceInfoReq,
  RecordTraceVo,
} from "./afterSales.interface";

interface AddressListData {
  addressList: AddressVo[];
}
interface ApplyReasonListData {
  data: ApplyReasonResVo[];
}

interface PostHouseListRes {
  data: PostHouseListResVo;
}

interface RecordApplyInfoData {
  data: RecordApplyInfoResVo;
}

interface RecordApplyCreateRes {
  data: RecordApplyCreateResVo;
}

interface RecordListRes {
  data: RecordListResVo[];
}

interface RecordDetailRes {
  data: RecordDetailResVo;
}

interface CancelAfsRecorRes {
  data: CancelAfsRecorResVo;
}

interface RuleInfoRes {
  ruleVOList: RuleInfoVO[];
}

interface RecordTraceRes {
  data: RecordTraceVo;
}
// 查询地址列表的 API 方法
export const fetchAddressList = (): Promise<AddressVo[]> => {
  return newColorAxiosInstance.get<AddressListData>("user_address_getList").then((response: any) => {
    return response.data.data?.addressList || [];
  });
};

// 查询支持的售后原因
export const fetchApplyReasonList = (requestData: IApplyReasonReq): Promise<ApplyReasonResVo[]> => {
  return newColorAxiosInstance
    .get<ApplyReasonListData>("aftersale_refund_getApplyReason", {
      params: requestData,
    })
    .then((response: any) => {
      return response.data.data;
    });
};

// 获取驿站信息列表
export const fetchPostHouseList = (requestData: IPostHouseListReq): Promise<PostHouseListResVo[]> => {
  return newColorAxiosInstance
    .get<PostHouseListRes>(
      "aftersale_refund_getPostHouseInfo",
      {
        params: requestData,
      },
      false,
    )
    .then((response: any) => {
      return response.data.data;
    });
};

// 进入售后单申请详情页，订单以及退款相关信息
export const fetchRecordApplyInfo = (requestData: IRecordApplyInfoReq): Promise<RecordApplyInfoResVo> => {
  return newColorAxiosInstance
    .post<RecordApplyInfoData>("aftersale_refund_getItems", undefined, {
      params: { ...requestData },
    })
    .then((response: any) => {
      return response.data.data;
    });
};

// 创建售后服务单
export const recordApplyCreate = (requestData: IRecordApplyCreateReq): Promise<RecordApplyCreateResVo> => {
  return newColorAxiosInstance
    .get<RecordApplyCreateRes>("aftersale_refund_add", {
      params: requestData,
    })
    .then((response: any) => {
      return response.data.data;
    });
};

// 售后记录列表
export const fetchRecordList = (requestData: IRecordListReq): Promise<RecordListResVo[]> => {
  return newColorAxiosInstance
    .get<RecordListRes>("aftersale_refund_getListByOrderId", {
      params: requestData,
    })
    .then((response: any) => {
      return response.data.data;
    });
};

// 售后服务详情
export const fetchRecordDetail = (requestData: IRecordDetailReq): Promise<RecordDetailResVo> => {
  return newColorAxiosInstance
    .get<RecordDetailRes>("aftersale_refund_get", {
      params: requestData,
    })
    .then((response: any) => {
      return response.data.data;
    });
};

// 取消提交的售后单
export const cancelAfsRecord = (requestData: ICancelRecordReq): Promise<CancelAfsRecorResVo> => {
  return newColorAxiosInstance
    .get<CancelAfsRecorRes>("aftersale_refund_cancel", {
      params: requestData,
    })
    .then((response: any) => {
      return response.data;
    });
};

// 获取该用户名下的售后单列表
export const fetchRefundList = (requestData: IRefundListReq): Promise<RefundListApiResVo> => {
  return newColorAxiosInstance
    .get<RefundListApiResVo>("aftersale_refund_getList", {
      params: requestData,
    })
    .then((response: any) => {
      return response?.data;
    });
};

// 获取售后配置信息
export const fetchRuleInfo = (): Promise<RuleInfoRes> => {
  return newColorAxiosInstance
    .get<RuleInfoRes>("aftersale_refund_getRuleInfo", {
      params: {},
    })
    .then((response: any) => {
      return response?.data?.data;
    });
};

// 物流轨迹接口
export const fetchTraceInfo = (requestData: ITraceInfoReq): Promise<RecordTraceVo> => {
  return newColorAxiosInstance
    .get<RecordTraceRes>("aftersale_refund_getTrace", {
      params: requestData,
    })
    .then((response: any) => {
      return response?.data?.data;
    });
};
